import { FC, useState, useEffect, Children, isValidElement } from 'react'

import './style.scss'

type TabsProps = {
  className?: string
}

type TabProps = {
  id?: string,
  name: string,
  active?: boolean,
  width?: string,
}

const Tabs:FC<TabsProps> = ({ children, className }) => {
  const [tabHeader, setTabHeader] = useState<any[]>([])
  const [childContent, setChildConent] = useState<any[]>([])
  const [active, setActive] = useState<string>('')

  useEffect(() => {
    const headers: any[] = []
    const childCnt: any[] = []

    Children.forEach(children, (element) => {
      if (!isValidElement(element)) return

      const { name } = element.props
      headers.push(name)
      childCnt[name] = element.props.children
    })
    setTabHeader(headers)
    setActive(headers[0])
    setChildConent({ ...childCnt })
  }, [children])

  const onTabChange = (name: string) => {
    setActive(name);
  }

  return (
    <div className={`tabs ${className}`}>
      <ul className="tabs_link">
        {tabHeader.map((item) => (
          <li
            key={item}
            className={`tab ${item === active ? 'tab--active' : ''}`}
            onClick={() => onTabChange(item)}
          >
            {item}
          </li>
        ))}
      </ul>

      {Object.keys(childContent).map((key: any) => {
        if (key === active) {
          return <div className="tab_content">{childContent[key]}</div>;
        } else {
          return null;
        }
      })}
    </div>
  )
}

const Tab:FC<TabProps> = ({ children, name, id, active = false, width = '' }) => {
  return (
    <div id={id} className={`tab_content ${active ? 'tab--active' : ''}`} style={{ width }}>
      {children}
    </div>
  )
}

export { Tabs, Tab }